import { render } from "./emphistory.vue?vue&type=template&id=2505b912"
import script from "./emphistory.vue?vue&type=script&lang=js"
export * from "./emphistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__